import { render, staticRenderFns } from "./billing-column-modal.component.vue?vue&type=template&id=4d8a4688&scoped=true&"
import script from "./billing-column-modal.component.vue?vue&type=script&lang=ts&"
export * from "./billing-column-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./billing-column-modal.component.vue?vue&type=style&index=0&id=4d8a4688&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a4688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VCol,VDialog,VDivider,VRow})
